/**
 * @param {{ track: (name: string, parameters: Record<string, string>) => void }} analytics
 */
export function createAnalyticsClickDirective(analytics) {
  if (!analytics || typeof analytics.track !== 'function') throw new Error('UI click analytics tracker is required')
  const stateByElement = new WeakMap()

  function mounted(element, binding) {
    const state = { metadata: clickMetadata(binding.value), onClick: null }
    state.onClick = () => {
      if (element.disabled || element.getAttribute('aria-disabled') === 'true') return
      analytics.track('ui_click', state.metadata)
    }
    stateByElement.set(element, state)
    element.addEventListener('click', state.onClick)
  }

  function updated(element, binding) {
    const state = stateByElement.get(element)
    if (!state) throw new Error('UI click analytics directive updated before mount')
    state.metadata = clickMetadata(binding.value)
  }

  function unmounted(element) {
    const state = stateByElement.get(element)
    if (!state) return
    element.removeEventListener('click', state.onClick)
    stateByElement.delete(element)
  }

  return Object.freeze({ mounted, updated, unmounted })
}

function clickMetadata(value) {
  if (!value || typeof value !== 'object') throw new Error('UI click analytics metadata is required')
  for (const key of ['element_id', 'surface']) {
    if (typeof value[key] !== 'string' || value[key] === '') throw new Error(`UI click analytics ${key} is required`)
  }
  if (value.scenario_id !== undefined && (typeof value.scenario_id !== 'string' || value.scenario_id === '')) {
    throw new Error(`Invalid UI click analytics scenario_id: ${String(value.scenario_id)}`)
  }
  return Object.freeze({ ...value })
}
